export default __webpack_public_path__ + "static/media/ic_check_inactive.a251033a.svg";